<template>
	<div class="site" id="site">
		<nav class="nav">
			<ul class="nav-menu">
				<li class="nav-menu__item">
					<router-link to="/about">
						<span class="fas fa-user"></span>
						About
					</router-link>
				</li>
				<li class="nav-menu__item">
					<router-link to="/resume">
						<span class="fas fa-file-alt"></span>
						Resume
					</router-link>
				</li>
				<!--li class="nav-menu__item">
					<router-link to="/projects">
						<span class="fas fa-briefcase"></span>
						Projects
					</router-link>
				</li-->
				<li class="nav-menu__item">
					<router-link to="/contact">
						<span class="fas fa-at"></span>
						Contact
					</router-link>
				</li>
			</ul>
		</nav>
		<transition
			name="fade"
			mode="out-in"
		>
			<router-view/>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Site'
}
</script>

<style>
@font-face {
	font-family: "osp-din";
	src: url(assets/fonts/OSP-DIN.ttf);
}

html, body {
	font-family: "Trebuchet MS", "Arial Narrow", Arial, sans-serif;
	font-size: 10px;
	height: 100vh;
	margin: 0;
	padding: 0;
	width: 100vw;
}

body {
	overflow-x: hidden;
}

a[href] {
	color: #1560e0;
	transition: color .5s;
}
a[href]:visited {
	color: #1560e0;
}
a[href]:hover {
	color: black;
}

.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0
}

.site {
	display: grid;
	font-size: 1.8rem;
	grid-template-areas: "nav main";
	grid-template-columns: 20rem auto;
	grid-template-rows: auto;
	height: 100vh;
	width: 100vw;
}
@media screen and (max-width: 920px) {
	.site {
		grid-template-areas: "nav" "main";
		grid-template-columns: auto;
	}
}

.nav {
	align-items: center;
	background: #222;
	display: flex;
	flex-direction: row;
	grid-area: "nav";
	justify-content: center;
}

.nav-menu {
	display: flex;
	flex-direction: column;
	list-style: none;
	margin: 0;
	padding: 0;
	text-transform: uppercase;
	width: auto;
}
@media screen and (max-width: 920px) {
	.nav-menu {
		flex-direction: row;
	}
}
.nav-menu__item {
	display: block;
	margin: 0;
	padding: 0;
	width: 100%;
}
@media screen and (max-width: 920px) {
	.nav-menu__item {
		margin: 0 2rem;
	}
}
.nav-menu__item:last-child {
	border-bottom: none;
}
.nav-menu__item a[href] {
	color: #fff;
	display: block;
	font-family: "osp-din", "Trebuchet MS", "Arial Narrow", Arial, sans-serif;
	font-size: 2.8rem;
	letter-spacing: .1rem;
	padding: 2rem 0;
	text-align: center;
	text-decoration: none;
	transition: color .5s;
	width: 100%;
}
.nav-menu__item a[href]:hover {
	color: #91c5ff;
}
.nav-menu__item a[href] .fa,
.nav-menu__item a[href] .fas {
	border-bottom: .1rem solid #ddd;
	display: block;
	font-size: 2rem;
	margin-bottom: .5rem;
	padding-bottom: 1rem;
	transition: border-color .5s;
}
.nav-menu__item a[href]:hover .fa, 
.nav-menu__item a[href]:hover .fas {
	border-color: #91c5ff;
}

.main {
	color: #333;
	grid-area: "main";
	overflow-x: hidden;
	overflow-y: auto;
}
@media screen and (max-width: 920px) {
	.main {
		overflow: visible;
	}
}
.main:after {
	display: block;
	content: "";
	height: 10rem;
}

.main p {
	line-height: 3rem;
	margin: 2rem 0;
}
.main p:first-child {
	margin-top: 0;
}
.main p:last-child {
	margin-bottom: 0;
}

.main__header {
	background-color: #f6f6f6;
	background-image: url(assets/header-bg.jpg);
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
	box-shadow: inset 0 0 100px #999;
	display: block;
	margin: 0 0 4rem 0;
	padding: 1rem;
}

.main__header .image--centered {
	margin-top: 2rem;
}
.main__header .heading {
	padding: 2rem 0;
}
.main__section {
	padding-top: 6rem;
}

.container {
	display: block;
	margin: 0 auto;
	max-width: 61.2rem;
	padding: 0 4rem;
}
.container--large {
	max-width: 100rem;
}
.container--fit {
	align-items: center;
	display: flex;
	justify-content: center;
	flex-direction: row;
}

.heading {
	color: #000;
	display: block;
	font-family: "osp-din", "Trebuchet MS", "Arial Narrow", Arial, sans-serif;
	letter-spacing: .2rem;
	line-height: 1.3;
	margin: 0;
	padding: 5rem 0;
	text-align: center;
	text-transform: uppercase;
	width: 100%;
}
.heading--subsection,
.heading--trisection {
	margin-bottom: 1rem;
	padding-bottom: 0;
	padding-top: 0;
	text-align: left;
}
.heading--trisection {
	margin-bottom: 1rem;
	margin-top: 3rem;
	padding-bottom: 0;
}
.heading--subsection:first-child,
.heading--trisection:first-child {
	margin-top: 0;
}
.heading--subsection:last-child,
.heading--trisection:last-child {
	margin-bottom: 0;
}
.heading__title {
	display: block;
	font-size: 4.2rem;
}
.heading--subsection .heading__title {
	font-size: 3.2rem;
}
.heading--trisection .heading__title {
	display: inline-block;
	font-size: 2.4rem;
	margin-right: 2rem;
}
.heading__subtitle {
	font-family: "Arial Narrow", Arial, sans-serif;
	font-size: 1.2rem;
	letter-spacing: .1rem;
}
.heading__subtitle + .heading__subtitle {
	margin-top: .5rem;
}

.image {
	display: inline-block;
	height: auto;
	width: 100%;
}
.image--centered {
	display: block;
	margin: 0 auto;
}
.image--circular {
	border-radius: 100vh;
}
.image--medium {
	width: 20rem;
}
.image--medium.image--circular {
	height: 20rem;
}
.image--bordered {
	border-color: #ccc;
	border-style: solid;
	border-width: .2rem;
}

.icon-links {
	display: flex;
	flex-direction: row;
	justify-content: center;
	list-style: none;
	margin: 0;
	padding: 0;
}
.icon-links--separator .icon-links__item {
	align-items: center;
	display: flex;
	flex-direction: row;
}
.icon-links--separator .icon-links__item:before,
.icon-links--separator .icon-links__item:after {
	background: #ccc;
	content: '';
	display: block;
	height: .2rem;
	width: 5rem;
}
.icon-links__item {
	margin: 0;
	padding: 0;
}
.icon-links__link {
	display: block;
	padding: 1rem;
	text-align: center;
	text-decoration: none;
}
.icon-links__link .fa,
.icon-links__link .fas,
.icon-links__link .fab {
	display: block;
	font-size: 4rem;
	margin-bottom: .5rem;
}

.list {
	padding-left: 1.75rem;
}
.list li {
	padding: .5rem 0;
}
.list--basic {
	list-style: none;
	margin: 0;
	padding: 0;
}
.list--icons .fa,
.list--icons .fas,
.list--icons .fab {
	display: inline-block;
	margin-right: .5rem;
}

.row {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin: 0 -2rem;
	width: 100%;
}
.row + .row {
	margin-top: 3rem;
}
.column {
	box-sizing: border-box;
	display: block;
	padding: 0 2rem;
	width: calc(100%/12);
}
.column--1 {
	width: calc(1/12 * 100%);
}
.column--2 {
	width: calc(2/12 * 100%);
}
.column--3 {
	width: calc(3/12 * 100%);
}
.column--4 {
	width: calc(4/12 * 100%);
}
.column--5 {
	width: calc(5/12 * 100%);
}
.column--6 {
	width: calc(6/12 * 100%);
}
.column--7 {
	width: calc(7/12 * 100%);
}
.column--8 {
	width: calc(8/12 * 100%);
}
.column--9 {
	width: calc(9/12 * 100%);
}
.column--10 {
	width: calc(10/12 * 100%);
}
.column--11 {
	width: calc(11/12 * 100%);
}
.column--12 {
	width: calc(12/12 * 100%);
}

@media screen and (max-width: 1100px) {
	.column--sm-1 {
		width: calc(1/12 * 100%);
	}
	.column--sm-2 {
		width: calc(2/12 * 100%);
	}
	.column--sm-3 {
		width: calc(3/12 * 100%);
	}
	.column--sm-4 {
		width: calc(4/12 * 100%);
	}
	.column--sm-5 {
		width: calc(5/12 * 100%);
	}
	.column--sm-6 {
		width: calc(6/12 * 100%);
	}
	.column--sm-7 {
		width: calc(7/12 * 100%);
	}
	.column--sm-8 {
		width: calc(8/12 * 100%);
	}
	.column--sm-9 {
		width: calc(9/12 * 100%);
	}
	.column--sm-10 {
		width: calc(10/12 * 100%);
	}
	.column--sm-11 {
		width: calc(11/12 * 100%);
	}
	.column--sm-12 {
		width: calc(12/12 * 100%);
	}
}

@media screen and (max-width: 600px) {
	.column--xs-1 {
		width: calc(1/12 * 100%);
	}
	.column--xs-2 {
		width: calc(2/12 * 100%);
	}
	.column--xs-3 {
		width: calc(3/12 * 100%);
	}
	.column--xs-4 {
		width: calc(4/12 * 100%);
	}
	.column--xs-5 {
		width: calc(5/12 * 100%);
	}
	.column--xs-6 {
		width: calc(6/12 * 100%);
	}
	.column--xs-7 {
		width: calc(7/12 * 100%);
	}
	.column--xs-8 {
		width: calc(8/12 * 100%);
	}
	.column--xs-9 {
		width: calc(9/12 * 100%);
	}
	.column--xs-10 {
		width: calc(10/12 * 100%);
	}
	.column--xs-11 {
		width: calc(11/12 * 100%);
	}
	.column--xs-12 {
		width: calc(12/12 * 100%);
	}
}

</style>



// WEBPACK FOOTER //
// src/Site.vue